import styled from 'styled-components';

export const Container = styled.div`
  width: 864px;

  li {
    background-color: #fff !important;
    text-align: start !important;
  }

  padding-bottom: 6px;
  margin-top: 24px;
`;

export const CaroulselIndicator = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: 100%;
`;

export const Indicator = styled.div`
  height: ${props => (props.active ? 8 : 6)}px;
  width: ${props => (props.active ? 8 : 6)}px;
  border-radius: 4px;
  background-color: ${props => (props.active ? '#9000FF' : '#ACBEC7')};
  margin-top: 10px;

  & + div {
    margin-left: 6px;
  }

  cursor: pointer;
`;
